import HttpRequest from'../../http/index.js';import {MARS_CORE_SERVER_PATH}from'@monorepo/shared';/*
 * @Author: 陈力恒
 * @LastEditors: 陈力恒
 * @Date: 2022-08-02 09:39:54
 * @LastEditTime: 2022-08-08 20:54:14
 * @Description: file content
 */
/** 保存操作日志 */
const saveSystemLog = (data) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/system_logs.json`,
        method: 'POST',
        data,
    });
};
/** 批量保存操作日志 */
const batchSaveSystemLog = (data) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/system_logs/batch_save.json`,
        method: 'POST',
        data,
    });
};
/** 保存操作日志 */
const GetSystemLog = (data, isReturnAxiosError) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/system_logs.json`,
        data,
        options: {
            isReturnAxiosError,
        },
    });
};
/** 查询指定操作功能在目标时间前的最近一条日志。 */
const getLatestOperateItem = (params) => HttpRequest({
    url: `${MARS_CORE_SERVER_PATH}/system_logs/latest_operate_item.json`,
    method: 'GET',
    params,
    // 该接口后端按字面值解析“+”，需要将时间中的空格编码为 %20。
    paramsSerializer: {
        serialize: (queryParams) => Object.entries(queryParams)
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
            .join('&'),
    },
});
/** 查询物品日志列表 */
const GetProductVariantMaterialLogs = (data) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/product_variant_material_logs.json`,
        data,
    });
};
// 定义获取系统日志详情的接口函数
const GetSystemLogDetail = (id) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/system_logs/${id}.json`,
        method: 'GET',
    });
};
// 定义获取系统日志详情的接口函数
const GetProductVariantMaterialSystemLogDetail = (id) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/product_variant_material_logs/${id}.json`,
        method: 'GET',
    });
};export{GetProductVariantMaterialLogs,GetProductVariantMaterialSystemLogDetail,GetSystemLog,GetSystemLogDetail,batchSaveSystemLog,getLatestOperateItem,saveSystemLog};//# sourceMappingURL=system.service.js.map
